import { createSlice, createSelector } from '@reduxjs/toolkit';

import { Colors } from '_styles'

const darkMode = {
  TEXT_COLOR: 'white',
  BACKGROUND_COLOR: '#121212',
  BORDER_COLOR: '#36454F',
  BUTTON_VARIANT: 'dark',
  TIMELINE_COLOR: '#303030',
  JOB_LIST_COLOR: Colors.GRAY_LIGHT
};

const lightMode = {
  TEXT_COLOR: 'black',
  BACKGROUND_COLOR: 'white',
  BORDER_COLOR: 'lightgray',
  BUTTON_VARIANT: 'light',
  TIMELINE_COLOR: '#F5F5F5',
  JOB_LIST_COLOR: Colors.GRAY_MEDIUM
};

const initialState = {
  darkMode: false,
  usedTheme: lightMode,
};

const themeSlice = createSlice({
  name: 'theme',
  initialState,
  reducers: {
    setDarkMode: (state, action) => {
      state.darkMode = action.payload;
      state.usedTheme = action.payload ? darkMode : lightMode;
    },
  },
});

export const { setDarkMode } = themeSlice.actions;

// Base selector
const selectThemeState = (state) => state.theme;

// OPTIMIZED: Memoized selectors
export const selectDarkMode = createSelector(
  [selectThemeState],
  (themeState) => themeState.darkMode
);

export const selectUsedTheme = createSelector(
  [selectThemeState],
  (themeState) => themeState.usedTheme
);

export default themeSlice.reducer;
